import React from 'react';
import StatsDisplayCustomerApiKey from "../../../topbars/StatsDisplayCustomerApiKey";

interface ApiKeyOverviewTabProps {
  apiKeyId: number;
}

const ApiKeyOverviewTab: React.FC<ApiKeyOverviewTabProps> = ({ apiKeyId }) => {
  return (
    <div>
      <StatsDisplayCustomerApiKey
        apiKeyId={apiKeyId}
        onTileSelect={(tile) => console.log('Selected tile:', tile)}
      />
    </div>
  );
};

export default ApiKeyOverviewTab;
